import { ZAttrType } from "src/business/attribute";
import { ZAttrComponent } from "src/business/attribute/attrEdits";
import { ZAttrViewComponent } from "src/business/attribute/attrViews/ZAttrViewComponent";

export const dictViewsForTypes: Record<
  ZAttrType,
  ZAttrViewComponent["type"][]
> = {
  string: ["LongText"],
  number: [],
  boolean: [],
  strOption: ["Link", "Image"],
  dateTime: [],
  file: ["Files"],
  list: [],
  array: ["Image", "Files"],
};

export const dictEditsForTypes: Record<ZAttrType, ZAttrComponent["type"][]> = {
  string: ["Input", "TextArea"],
  number: ["InputNumber"],
  boolean: ["Switch"],
  strOption: [
    "Select",
    "AttrExternalImages",
    "RecordSelect",
    "SelectValuesModal",
  ],
  dateTime: ["DatePicker"],
  file: ["Uploader"],
  list: [],
  array: ["AttrExternalImages", "Uploader", "RecordSelect"],
};
